import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { CategoryLineItemsPage } from './CategoryLineItemsPage';

const searchSchema = z.object({
  month: z.string().optional(),
});

export const Route = createFileRoute('/_protected/_consumer/insights/category/$categoryName/')({
  component: CategoryLineItemsPage,
  validateSearch: searchSchema,
});
